<template>
  <VSpinner v-if="!product" class="offset-top-16 offset-bottom-17" />
  <article v-else>
    <div id="PRODUCT_ADMINISTRATION_CONFIRMATION" class="container-fixed">
      <VProgress v-if="flags.progressBarEnabled" class="offset-top-2 offset-bottom-2" :steps="steps" active="substore.progress_confirmation" />

      <VSection cluster label="substore.administration_completed">
        <div v-if="product.texts.productAdministrationConfirmation">
          <br />
          <p v-html="product.texts.productAdministrationConfirmation"></p>
        </div>
        <div v-if="product.texts.productAdministrationConfirmationHint">
          <br />
          <p v-html="product.texts.productAdministrationConfirmationHint"></p>
        </div>
      </VSection>

      <section class="offset-top-2 pull-right offset-right-1 button-bar">
        <router-link class="btn btn-default btn-brand" :to="{ name: STOCK }">
          {{ $t('common.navigation_STOCK') }}
        </router-link>
      </section>
    </div>

    <div class="container-fixed offset-top-6">
      <VFootnotes :footnotes="footnotes" />
    </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import AdministrationProxy from '@/proxies/SubstoreAdministrationProxy';
import Transformer from '@/transformers/ProductAdministrationConfirmationTransformer';
import Footnotes from '@/utils/Footnotes';
import TitleMixin from '@/mixins/title';
import OrderStepsMixin from '@/mixins/orderSteps';
import VSpinner from '@/components/Spinner';
import VSection from '@/components/Section';
import { STOCK } from '@route-types';

export default {
  name: 'ProductAdministrationConfirmation',

  components: {
    VSpinner,
    VSection,
    VProgress: () => import('@/components/Progress'),
    VFootnotes: () => import('@/components/UI/Footnotes'),
  },

  mixins: [TitleMixin, OrderStepsMixin],

  props: {
    subscriptionTemplateId: {
      type: String,
      required: true,
    },

    uniqueSubscriptionId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      STOCK,
      product: null,
      footnotes: null,
      flags: {
        progressBarEnabled: null,
      },
    };
  },

  computed: {
    ...mapGetters('system', ['hasAccessCatalogue', 'hasAccessStockOverview']),
  },

  async created() {
    const response = await new AdministrationProxy().orderAdministrationConfirmationDialogData(this.subscriptionTemplateId, this.uniqueSubscriptionId);

    if (response.head.fault !== null) throw new Error(response.head.fault);

    Object.keys(this.flags).forEach(key => {
      this.flags[key] = response.data[key];
    });

    this.footnotes = new Footnotes();

    this.product = Transformer.fetch(response.data.product, this.footnotes);

    this.$webtrekk.viewPageWithPayload('administrationbestaetigung', {
      page_type: 'basket',
      shop_product_sku: this.subscriptionTemplateId,
      shop_product_name: this.product.texts?.productName,
    });
  },
};
</script>

<style scoped>
.button-bar > span {
  position: relative;
  top: 1px;
  display: inline-block;
}
</style>
